export default __webpack_public_path__ + "static/media/demolka.c26dab70.png";